const settings = require('../../server/settings')
module.exports = {
    api:'http://'+settings.api_root,
    // api:'http://'+settings.api_root + '/api',
    mpmanagebackapi:'http://'+settings.mpmanageback + '/api',
    timeout: 30000
}



// WEBPACK FOOTER //
// ./src/api/config-client.js